import React, { PureComponent } from "react";
import './Menu.css';
import Button from '../Button/Button.js';
import Constants from '../Constants.js';
import PlatformTest from '../PlatformTest.js';

import icon from '../assets/media/icon.png';

import './Menu.css';

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLightbulb, faQuestion, faStar, faHeart, faBan } from '@fortawesome/free-solid-svg-icons';
import { faTwitter, faFacebook } from '@fortawesome/free-brands-svg-icons';
import { faApple, faAndroid } from '@fortawesome/free-brands-svg-icons';
library.add(faLightbulb, faQuestion, faStar, faTwitter, faFacebook, faApple, faAndroid, faHeart);


class Header extends PureComponent {
    render() {
        return (
            <div
                className="HeaderWrapper"
                style={{
                    backgroundColor: '#FBFBFB',
                }}
            >
                <div
                    style={{
                        position: 'relative',
                        width: '100%',
                        maxWidth: '520px',
                        left: '50%',
                        padding: '80px 20px 80px 20px',
                        transform: 'translateX(-50%)',
                        boxSizing: 'border-box',
                    }}
                >
                    {
                        (!Constants.appVersion || Constants.coolmathVersion) &&
                        <img
                            src={icon}
                            alt="logo"
                            className="HeaderLogo"
                            style={{
                                width: '92px',
                                height: '92px',
                                marginBottom: '15px',
                                filter: 'drop-shadow(0 5px 15px rgba(0,0,0,0.15))',
                                overflow: 'visible',
                                cursor: 'pointer',
                            }}
                        />
                    }

                    <h1
                        className="Title"
                        style={{
                            fontSize: '38px',
                            color: '#130f40',
                            textShadow: '0 2px 10px rgba(0,0,0,0.05)',
                        }}
                    >
                        {Constants.name}
                    </h1>
                    {
                        !(!Constants.appVersion || Constants.coolmathVersion) &&
                        <p
                            className="Paragraph"
                            style={{
                                color: '#130f40',
                                opacity: '0.7',
                            }}
                        >
                            A puzzle game about forming words and clearing levels
                        </p>
                    }

                    <div
                        style={{
                            marginTop: '30px',
                        }}
                    >
                        <Button
                            inactiveColor={'#130f40'}
                            activeColor={'#FBFBFB'}
                            borderColor={'#130f40'}
                            onClick={() => {
                                if (typeof this.props.onTutorialInit === 'function')
                                    this.props.onTutorialInit();
                            }}
                        >
                            <FontAwesomeIcon className="ButtonIcon" icon="question" />
                            How to Play
                        </Button>
                        {
                            // Display "Rate App" button if this is the iOS app version
                            (Constants.appVersion && !Constants.coolmathVersion && PlatformTest.ios()) &&
                            <div>
                                <Button
                                    inactiveColor={'#FBFBFB'}
                                    activeColor={'#130f40'}
                                    borderColor={'#130f40'}
                                    onClick={() => {
                                        if (typeof this.props.onRateApp === 'function')
                                            this.props.onRateApp();
                                    }}
                                >
                                    <FontAwesomeIcon className="ButtonIcon" icon={faHeart} />
                                    Rate App
                                </Button>
                            </div>
                        }
                        {
                            // Option to remove ads
                            (!this.props.data.removedAds && Constants.appVersion && !Constants.coolmathVersion) &&
                            <div>
                                <Button
                                    inactiveColor={'#FBFBFB'}
                                    activeColor={'#130f40'}
                                    borderColor={'#130f40'}
                                    onClick={() => {
                                        if (window.store) {
                                            window.store.order('removenonoptionalads');
                                        }
                                    }}
                                >
                                    <FontAwesomeIcon className="ButtonIcon" icon={faBan} />
                                    Remove Ads
                                </Button>
                            </div>
                        }
                        {
                            (!Constants.coolmathVersion && !Constants.appVersion && PlatformTest.ios()) &&
                            <div>
                                <a href={Constants.iosDownloadLink} target="_blank" rel="noopener noreferrer">
                                    <Button
                                        inactiveColor={'#130f40'}
                                        activeColor={'#FBFBFB'}
                                        borderColor={'#130f40'}
                                    >
                                        <FontAwesomeIcon className="ButtonIcon" icon={faApple} />
                                        Download App
                                    </Button>
                                </a>
                            </div>
                        }
                        {
                            (!Constants.coolmathVersion && !Constants.appVersion && PlatformTest.android()) &&
                            <div>
                                <a href={Constants.androidDownloadLink} target="_blank" rel="noopener noreferrer">
                                    <Button
                                        inactiveColor={'#130f40'}
                                        activeColor={'#FBFBFB'}
                                        borderColor={'#130f40'}
                                    >
                                        <FontAwesomeIcon className="ButtonIcon" icon={faAndroid} />
                                        Download App
                                    </Button>
                                </a>
                            </div>
                        }
                    </div>
                </div>


                {
                    !Constants.coolmathVersion &&
                    <div style={{
                        position: 'absolute',
                        top: '100%',
                        left: '50%',
                        transform: 'translate(-50%, -50%) scale(0.8)',
                        whiteSpace: 'nowrap',
                    }}>
                        <a href={Constants.twitterShareLink} target="_blank" rel="noopener noreferrer">
                            <Button
                                activeColor={'#38A1F3'}
                                inactiveColor={'#fff'}
                                borderColor={'#fff'}
                                activeBorderColor={'#38A1F3'}
                                onClick={() => {
                                }}
                            >
                                <FontAwesomeIcon className="ButtonIcon" icon={faTwitter} />
                                Tweet
                            </Button>
                        </a>
                        <a href={Constants.facebookShareLink} target="_blank" rel="noopener noreferrer">
                            <Button
                                activeColor={'#1777F2'}
                                inactiveColor={'#fff'}
                                borderColor={'#fff'}
                                activeBorderColor={'#1777F2'}
                                onClick={() => {
                                }}
                            >
                                <FontAwesomeIcon className="ButtonIcon" icon={faFacebook} />
                                Share
                            </Button>
                        </a>
                    </div>
                }

            </div>
        );
    }
}

export default Header;
